// @ts-nocheck
import React from 'react';
import { Input, AtsTip, FormSection, FormNav } from '../FormField';
import { ATS_TIPS } from '../../data/initialData';

export default function SkillsTab({ data, onChange, onBack, onNext }) {
  const upd = (key) => (val) => onChange({ ...data, [key]: val });

  return (
    <div>
      {/* <AtsTip {...ATS_TIPS.skills} /> */}

      <div style={{
        background: '#fefce8',
        border: '1px solid #fde68a',
        borderRadius: 10,
        padding: '10px 14px',
        marginBottom: 20,
        fontSize: 12,
        color: '#78350f',
        display: 'flex',
        gap: 8,
        alignItems: 'flex-start',
      }}>
        <span style={{ fontSize: 14, lineHeight: 1.4 }}>💡</span>
        <span><strong>Format tip:</strong> Enter skills as comma-separated values. E.g: <em>Python, JavaScript, React, SQL</em></span>
      </div>

      <FormSection title="Technical Skills">
        <Input
          label="Programming Languages"
          hint="comma-separated"
          value={data.languages}
          onChange={upd('languages')}
          placeholder="Python, JavaScript, TypeScript, Java, C++, C, SQL"
        />
        <Input
          label="Frameworks & Libraries"
          hint="comma-separated"
          value={data.frameworks}
          onChange={upd('frameworks')}
          placeholder="React, Next.js, Node.js, Express, Django, Flask, Spring Boot, FastAPI"
        />
        <Input
          label="Databases"
          hint="comma-separated"
          value={data.databases}
          onChange={upd('databases')}
          placeholder="PostgreSQL, MongoDB, MySQL, Redis, Firebase, Supabase"
        />
        <Input
          label="Cloud, DevOps & Tools"
          hint="comma-separated"
          value={data.cloud}
          onChange={upd('cloud')}
          placeholder="AWS, GCP, Azure, Docker, Kubernetes, Git, GitHub Actions, Vercel, Linux"
        />
        <Input
          label="Other Technical Skills"
          hint="comma-separated"
          value={data.technical}
          onChange={upd('technical')}
          placeholder="Machine Learning, REST APIs, GraphQL, System Design, Data Structures, MERN Stack"
        />
      </FormSection>

      <FormSection title="Soft Skills">
        <Input
          label="Soft Skills"
          hint="comma-separated"
          value={data.soft}
          onChange={upd('soft')}
          placeholder="Team Leadership, Problem Solving, Communication, Critical Thinking, Mentoring"
        />
      </FormSection>

      <FormNav showBack onBack={onBack} showNext onNext={onNext} nextLabel="Next: Certifications →" />
    </div>
  );
}
